import { isRecord } from './isRecord';

// gloss
export const parseJsonColumn = (raw: unknown): unknown => {
  if (raw == null) return null;
  if (typeof raw !== 'string') return raw;
  if (!raw.trim()) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

// gloss
export const parseJsonRecord = (raw: unknown): Record<string, unknown> | null => {
  const parsed = parseJsonColumn(raw);
  return isRecord(parsed) ? parsed : null;
};
